module.exports = {
	"articleTitle1": "On Main Street, shopping gives way to gourmet scene",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Real Seafood Company",
	"articleLink1": "https://www.michigandaily.com/news/main-street-profile",
	"articleLink2": "https://www.michigandaily.com/content/best-ann-arbor",
	"articleSnippet1": "Dec 2, 2013 ... Dennis Serras, owner of Real Seafood Company since 1975 said he has \nwatched Main Street's decline in shopping attractions since the ...",
	"articleSnippet2": "Apr 12, 2006 ... Best Moving Company: Two Men and a Truck Best Musical Instruments: King's ... \nBest Place for the Folks To Treat You: Real Seafood Company",
	"foodRecommendations": [],
	"articleTitle2": "The Best of Ann Arbor",
	"address": "341 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.27838,
		"lng": -83.748255
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/realseafoodcompany.json
// module id = 959
// module chunks = 0